// This file was auto-generated by Fern from our API Definition.
export const LicenseId = {
    Mit: "MIT",
    Apache2: "Apache-2.0",
};
